export function parseGoogleAddressComponents(components) {
  const fields = { address: "", city: "", state: "", zipCode: "" };

  components.forEach((component) => {
    const types = component.types;

    if (types.includes("street_number")) {
      fields.address = `${component.long_name} ${fields.address}`;
    }
    if (types.includes("route")) {
      fields.address += component.long_name;
    }
    if (types.includes("locality")) {
      fields.city = component.long_name;
    }
    if (!fields.city && (types.includes("sublocality") || types.includes("sublocality_level_1"))) {
      fields.city = component.long_name;
    }
    if (!fields.city && types.includes("administrative_area_level_2")) {
      fields.city = component.long_name;
    }
    if (types.includes("administrative_area_level_1")) {
      fields.state = component.long_name;
    }
    if (types.includes("postal_code")) {
      fields.zipCode = component.long_name;
    }
  });

  return fields;
}

export function enrichCityStateFromGeocoder(components, fields) {
  const next = { ...fields };
  components.forEach((component) => {
    const types = component.types;
    if (!next.city && types.includes("locality")) {
      next.city = component.long_name;
    }
    if (!next.state && types.includes("administrative_area_level_1")) {
      next.state = component.long_name;
    }
  });
  return next;
}

export function finishGooglePlaceSelection(place, callback, geocoderFactory) {
  const fields = parseGoogleAddressComponents(place.address_components);

  if ((!fields.city || !fields.state) && place.geometry?.location) {
    const geocoder = geocoderFactory();
    geocoder.geocode({ location: place.geometry.location }, (results, status) => {
      if (status !== "OK" || !results[0]) {
        return;
      }
      const enriched = enrichCityStateFromGeocoder(results[0].address_components, fields);
      if (callback) {
        callback(enriched.address, enriched.city, enriched.state, enriched.zipCode);
      }
    });
    return;
  }

  if (callback) {
    callback(fields.address, fields.city, fields.state, fields.zipCode);
  }
}
